module.exports = __webpack_public_path__ + "img/step1-b.5c6a6813.png";